export default "__VITE_ASSET__C$7yVbkN__"